import script from "./CoveoComponent.vue?vue&type=script&lang=js"
export * from "./CoveoComponent.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__